import { render, staticRenderFns } from "./NoResourceFoundMessage.vue?vue&type=template&id=bf60c598&scoped=true"
import script from "./NoResourceFoundMessage.vue?vue&type=script&lang=js"
export * from "./NoResourceFoundMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf60c598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf60c598')) {
      api.createRecord('bf60c598', component.options)
    } else {
      api.reload('bf60c598', component.options)
    }
    module.hot.accept("./NoResourceFoundMessage.vue?vue&type=template&id=bf60c598&scoped=true", function () {
      api.rerender('bf60c598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/NoResourceFoundMessage.vue"
export default component.exports